/**
 * PostHog se spouští teprve po souhlasu s kategorií "Analytika" (GDPR).
 * Stub `window.posthog` je připraven v public/index.html, ale `init()` se
 * volá výhradně odsud — bez souhlasu tedy neodejde žádný požadavek ani
 * nahrávání obrazovky.
 */
let started = false;

export function applyAnalyticsTools(analyticsAllowed) {
  const ph = window.posthog;
  const cfg = window.__APEX_POSTHOG__;
  if (!ph || !cfg) return;

  if (analyticsAllowed) {
    if (!started) {
      started = true;
      ph.init(cfg.key, {
        api_host: cfg.api_host,
        person_profiles: "identified_only",
        session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
      });
    } else {
      try { ph.opt_in_capturing(); ph.startSessionRecording?.(); } catch { /* ignore */ }
    }
    return;
  }

  // Souhlas odvolán → zastav nahrávání i sběr dat.
  if (started) {
    try { ph.stopSessionRecording?.(); ph.opt_out_capturing(); } catch { /* ignore */ }
  }
}
